import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User turned on auto-submit for content collection form',
  name: 'toggled_content_collection_form_auto_submit_on',
  params: [
    {
      description: 'ID of the content collection form',
      name: 'form_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
